import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import TrackingPage from "@/pages/TrackingPage";
import TrackingResult from "@/pages/TrackingResult";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CustomerLogin from "@/pages/CustomerLogin";
import CustomerDashboard from "@/pages/CustomerDashboard";
import QuotePage from "@/pages/QuotePage";
import ContactPage from "@/pages/ContactPage";
import WhatsAppButton from "@/components/WhatsAppButton";
import "@/App.css";

function App() {
  return (
    <ThemeProvider>
      <div className="App min-h-screen bg-slate-50 dark:bg-slate-950">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<TrackingPage />} />
            <Route path="/track/:trackingNumber" element={<TrackingResult />} />
            <Route path="/quote" element={<QuotePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/customer" element={<CustomerLogin />} />
            <Route path="/customer/dashboard" element={<CustomerDashboard />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
          <WhatsAppButton />
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </ThemeProvider>
  );
}

export default App;
